/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("web/script/polyfills/fetch");
var classListPolyfill = require("web/script/polyfills/classList");

import _ from "underscore";

// I heard you like regex?
var urlParseRE = /^(((([^:\/#\?]+:)?(?:(\/\/)((?:(([^:@\/#\?]+)(?:\:([^:@\/#\?]+))?)@)?(([^:\/#\?\]\[]+|\[[^\/\]@#?]+\])(?:\:([0-9]+))?))?)?)?((\/?(?:[^\/\?#]+\/+)*)([^\?#]*)))?(\?[^#]+)?)(#.*)?/;

var find = /[!'\(\)~]|%20|%00/g;
var plus = /\+/g;

// additional encoding that encodeURIComponent and decodeURIComponent don't handle
var replace = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\x00"
};

/**
 * URL encodes a string.
 * @param str
 * @returns {string}
 */
function encode(str) {
    return encodeURIComponent(str).replace(find, function(match) {
        return replace[match];
    });
}

/**
 * URL decodes a string.
 * @param str
 * @returns {string}
 */
function decode(str) {
    return decodeURIComponent(str.replace(plus, " "));
}

// used to create a private instance property on URLSearchParams instances.
var secret = "__URLSearchParams__:" + Math.random();

/**
 * URLSearchParams is a proposal by FireFox which provides utilities for working with a URL
 * query string. Although this is actually implemented in Firefox now it's not a standard
 * yet so we are always using this version. If and when more browsers implemented it it can
 * be moved to a polyfill.
 *
 * MDN Docs - https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
 * WhatWG Spec - https://url.spec.whatwg.org/#urlsearchparams
 *
 * @param {string|URLSearchParams} [query]
 * @constructor
 */
function URLSearchParams(query) {
    this[secret] = Object.create(null);

    if (query instanceof URLSearchParams) {
        this[secret] = query.toJSON();
        return;
    }

    if (!_.isString(query)) {
        return;
    }

    var pairs = (query || "").split("&");
    var length = pairs.length;
    var i = 0;
    var index;
    var value;

    for (; i < length; i++) {
        value = pairs[i];
        index = value.indexOf("=");

        if (index !== -1) {
            this.append(decode(value.slice(0, index)), decode(value.slice(index + 1)));
        }
    }
}

/**
 * Append `value` to `name`. If `name` does not already exist then it will be created.
 * @param {string} name
 * @param {*} value
 */
URLSearchParams.prototype.append = function(name, value) {
    var dict = this[secret];
    if (name in dict) {
        dict[name].push("" + value);
    } else {
        dict[name] = ["" + value];
    }
};

/**
 * Deletes `name`.
 * @param {string} name
 */
URLSearchParams.prototype.delete = function(name) {
    delete this[secret][name];
};

/**
 * Returns the first value in the params for `name` or null. To get all values for `name` use `getAll`.
 * @param {string} name
 * @returns {string|null}
 */
URLSearchParams.prototype.get = function(name) {
    var dict = this[secret];
    return name in dict ? dict[name][0] : null;
};

/**
 * Returns all values for `name` as an array. Will always return an array even if `name` does
 * not exist. Mutating the returned array will have no affect on the URLSearchParams instance.
 * @param {string} name
 * @returns {array}
 */
URLSearchParams.prototype.getAll = function(name) {
    var dict = this[secret];
    return name in dict ? dict[name].slice(0) : [];
};

/**
 * Returns true if `name` is present in the params.
 * @param {string} name
 * @returns {boolean}
 */
URLSearchParams.prototype.has = function(name) {
    return name in this[secret];
};

/**
 * Overwrites `name` with `value`. Any previous values stored under `name` will be lost.
 * @param {string} name
 * @param {*} value
 */
URLSearchParams.prototype.set = function(name, value) {
    this[secret][name] = ["" + value];
};

/**
 * Returns a serialized version of the current state of the URLSearchParams instance.
 * @returns {string}
 */
URLSearchParams.prototype.toString = function() {
    var dict = this[secret];
    var query = [];
    var i;
    var key;
    var name;
    var value;

    for (key in dict) {
        name = encode(key);

        for (i = 0, value = dict[key]; i < value.length; i++) {
            query.push(name + "=" + encode(value[i]));
        }
    }
    return query.join("&");
};

/**
 * Note: This method is a deviation from the spec
 * Returns an object representing the current state of the URLSearchParams instance. Mutating
 * the returned object will have no affect on the URLSearchParams instance.
 * The keys of the returned object will be the names of the params and the values will be arrays of values.
 * @returns {object}
 */
URLSearchParams.prototype.toJSON = function() {
    var dict = this[secret];
    var result = {};
    for (var key in dict) {
        result[key] = this.getAll(key);
    }
    return result;
};

export default {
    URLSearchParams: URLSearchParams,

    /**
     * Joins all arguments together ensuring there is a leading and trailing slash.
     * Any arguments that not non-empty strings are ignored.
     * @returns {string}
     */
    join: function() {
        var parts = _.reduce(
            arguments,
            function(result, part) {
                if (part && _.isString(part)) {
                    // replace
                    part = part.replace(/^\//, "").replace(/\/$/, "");

                    if (part) {
                        result.push(part);
                    }
                }

                return result;
            },
            []
        );

        if (parts.length) {
            return "/" + parts.join("/") + "/";
        }

        return "";
    },

    /**
     * Parses a URL into an object. The returns object can be mutated to change the URL and
     * then passed to `unparse` to get a URL string again.
     * @param {string} url
     * @returns {object}
     */
    parse: function(url) {
        var match = urlParseRE.exec(url);
        var search = match[16];

        if (search && search[0] === "?") {
            search = search.substring(1);
        }

        var parsed = {
            protocol: match[4] || "",
            host: match[6] || "",
            searchParams: new URLSearchParams(search),
            path: match[14] || "",
            hash: match[17] || ""
        };

        parsed.toString = this.unparse.bind(this, parsed);

        return parsed;
    },

    /**
     * Unparses an object with the same structure as returned from `parse` and returns a string.
     * For flexibility the `searchParams` property can be a URLSearchParams instance or just a plain object.
     * @param {object} parsed
     * @returns {string}
     */
    unparse: function(parsed) {
        var url = "";
        var queryString = this.toQueryString(parsed.searchParams);

        url += parsed.protocol ? parsed.protocol + "//" : "";
        url += parsed.host || "";
        url += parsed.path || "";
        url += queryString ? "?" + queryString : "";
        url += parsed.hash || "";

        return url;
    },

    /**
     * Turns a URLSearchParams instance or a plain object into an encoded query string.
     * @param {object|URLSearchParams} params
     * @returns {string}
     */
    toQueryString: function(params) {
        if (params instanceof URLSearchParams) {
            return params.toString();
        }

        var searchParams = new URLSearchParams();

        _.each(params, function(value, key) {
            if (value === undefined || value === null) {
                return;
            }
            if (_.isArray(value)) {
                value.forEach(searchParams.append.bind(searchParams, key));
            } else if (value !== null) {
                searchParams.append(key, value);
            }
        });

        return searchParams.toString();
    },

    /**
     * Creates a URLSearchParams instance from `obj`.
     * @param {URLSearchParams|object|string} obj
     * @returns {URLSearchParams}
     */
    toURLSearchParams: function(obj) {
        if (obj instanceof URLSearchParams) {
            return obj;
        }

        if (_.isString(obj)) {
            return new URLSearchParams(obj.replace(/^\?/, ""));
        }

        if (_.isObject(obj) && !_.isArray(obj)) {
            return new URLSearchParams(this.toQueryString(obj));
        }

        return new URLSearchParams();
    }
};

